module.exports = __webpack_public_path__ + "static/4-2b5ae1e41d3759c9c12118aa9a27608a.jpg";